export default "__VITE_ASSET__CSVioZRQ__"